import React from 'react';
import { Card, CardContent, Box, Typography, Chip } from '@mui/material';

const formatNumber = (num, decimals = 4) => {
  if (num === null || num === undefined) return '-';
  return Number(num).toLocaleString(undefined, { maximumFractionDigits: decimals });
};

const formatEpoch = (n) => {
  if (n === null || n === undefined) return 'N/A';
  try {
    return new Date(Number(n) * 1000).toLocaleString();
  } catch {
    return String(n);
  }
};

const truncate = (s, n = 14) => (!s ? '-' : s.length > n ? `${s.slice(0, n)}…` : s);

const KalshiStoryCard = ({ story }) => {
  if (!story || story.type !== 'bet') return null;
  const { market_id, bet = {} } = story;
  const side = (bet.side || '').toLowerCase();
  const sideColor = side === 'buy' ? 'success' : side === 'sell' ? 'error' : 'default';

  return (
    <Card sx={{ mb: 2, backgroundColor: '#fafafa' }}>
      <CardContent sx={{ pb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              {market_id || 'Unknown market'}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {bet.event_type || 'kalshi bet'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
            {side && <Chip size="small" label={side.toUpperCase()} color={sideColor} />}
            {bet.source && <Chip size="small" label={bet.source} variant="outlined" />}
          </Box>
        </Box>

        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 0.5, mt: 1.5 }}>
          <Typography variant="body2" color="text.secondary">Price</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{formatNumber(bet.price, 6)}</Typography>

          <Typography variant="body2" color="text.secondary">Amount</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{formatNumber(bet.amount, 0)}</Typography>

          <Typography variant="body2" color="text.secondary">Payout</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{formatNumber(bet.payout_amount, 4)}</Typography>

          <Typography variant="body2" color="text.secondary">Outcome mint</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{truncate(bet.outcome_mint)}</Typography>

          <Typography variant="body2" color="text.secondary">User</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{truncate(bet.user_id)}</Typography>

          <Typography variant="body2" color="text.secondary">Tx</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{truncate(bet.tx_hash)}</Typography>

          <Typography variant="body2" color="text.secondary">Time</Typography>
          <Typography variant="body2" sx={{ textAlign: 'right' }}>{formatEpoch(bet.block_time)}</Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default KalshiStoryCard;
